import { Component } from '@angular/core';
import { directus, Page } from '../../../../directus';
import { Router } from '@angular/router';
import { readItems } from '@directus/sdk';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pages',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pages.component.html',
  styleUrl: './pages.component.css'
})
export class PagesComponent {
  pages: Page[] | undefined;
  constructor(private router: Router) { }

  goToPage(slug: string) {
    this.router.navigate(['/pages', slug]);
  }

  ngOnInit(): void {
    this.getAllPages();
  }

  async getAllPages() {
    //@ts-ignore
    this.pages = await directus
      .request<Page[]>(readItems("pages", {
        fields: ["slug", "title", "content"]
      }));
  }
}
